import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { BillView } from '@/components/pages/Admin/BillManagement/View/BillView'
import { useGetBillById } from '@/modules/bill/services/bill'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/outstanding/$id/')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      tab: (search.tab as string) || 'buy',
      q: (search.q as string) || '',
    }
  },
  component: OutstandingViewPage,
})

function OutstandingViewPage() {
  const { id } = Route.useParams()
  const { tab, q } = Route.useSearch()
  const { data } = useGetBillById(id)
  const t = useTranslations('admin.bill_management')

  return (
    <HomeContentContainer
      title={t('bill_detail_title')}
      subtitle={t('bill_detail_subtitle')}
      contentClassName="max-w-full"
    >
      <BillView data={data} type="pending" tab={tab} q={q} />
    </HomeContentContainer>
  )
}

